export default {"src":"/_next/static/media/btch.75fcde39.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};